import axios from "axios";
import { API_URL } from "../constants/api";
import { useQuery } from "react-query";

const APIURL = axios.create({
  baseURL: API_URL,
});

const SPA = async (uuid, spa_id, lang) => {
  return await APIURL.get(`/${uuid}/spa/${spa_id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowSPA = (uuid, spa_id, lang) => {
  return useQuery(["spa", uuid, spa_id, lang], () => SPA(uuid, spa_id, lang));
};
